module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/textBlock.a7aede2b.svg";